export default "__VITE_ASSET__765f890d__"